"max-len"
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import { withRouter } from 'react-router-dom';

const _data = {};

class ThirdPartyQuestionnaire_ extends React.Component {
	state = {
		data: {},
		questions: null,
	};

	handleSubmit = () => {
		// console.log('Data Submitted')
	};

	onChangeInput = (event) => {

		_data[event.target.id] = {
			question_id: event.target.id,
			answer: event.target.value
		}

		this.setState({
			data: _data
		});

		// console.log(this.state)
	}


	render () {
		const quest = [
			{
				fields: {
					"id": 1,
					"policy_id": 1,
					"body": " 1 At vedolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam liberores repellat?",  // eslint-disable-line max-len
				},
			},
			{
				fields: {
					"id": 2,
					"policy_id": 1,
					"body": " 2 At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium erendis doloribus asperiores repellat?", // eslint-disable-line max-len
				},
			},
			{
				fields: {
					"id": 3,
					"policy_id": 1,
					"body": " 3 At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas ?",  // eslint-disable-line max-len
				},
			},
			{
				fields: {
					"id": 4,
					"policy_id": 1,
					"body": " 4 At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos ?",  // eslint-disable-line max-len
				},
			},
			{
				fields: {
					"id": 5,
					"policy_id": 1,
					"body": " 5 At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque ?",  // eslint-disable-line max-len
				},
			},
		]



		let renderQuestions = quest.map((item) => {
			return (
				<div key={item.fields.id} >
					<form autoComplete="off">
						<div>
							<div>
								<label
									className='form__form-group-label policy_questions_label'>
									{item.fields.id}. {item.fields.body}
								</label>
							</div>
							<div className='form__form-group-field'>
								<TextField
									id={'answer' + item.fields.id.toString()}
									required
									multiline
									fullWidth
									placeholder={this.state.name}
									margin="normal"
									onChange={this.onChangeInput}
								/>
							</div>
						</div>
					</form>
				</div>
			)
		})


		return (
			<div className="policy_questions">
				{
					<div>
						<div className="page-title">
							<h3 className='page-title'> Third Party Policy Questionnaire</h3>
							<h3 className='page-subhead subhead'>Answer the questions below</h3>
						</div>
						<div >
							{renderQuestions}
						</div>
						<div >
							<Button
								variant="contained"
								className='btn btn-primary ques_btn'
								onClick={this.handleSubmit} >
								Submit
                        </Button>
						</div>
					</div>
				}
			</div>

		);
	}



}


export default withRouter(ThirdPartyQuestionnaire_);



// WEBPACK FOOTER //
// ./src/components/policies/questionnaire/ThirdPartyQuestionnaire_.js